var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackToTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 96,
    viewBox: "0 0 79 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4995 95.0138C31.3323 95.0138 24.686 88.3675 24.686 80.2003V56.6765C19.0421 61.7328 9.74906 61.5106 4.33719 56.1086C1.56009 53.3307 0 49.5635 0 45.6355C0 41.7075 1.56009 37.9403 4.33719 35.1623L39.4995 0L74.6618 35.1623C77.4389 37.9403 78.999 41.7075 78.999 45.6355C78.999 49.5635 77.4389 53.3307 74.6618 56.1086C69.2598 61.5155 59.952 61.7377 54.313 56.6765V80.2003C54.313 88.3675 47.6667 95.0138 39.4995 95.0138ZM34.5617 32.8662V80.2003C34.6186 81.4717 35.1636 82.6722 36.0834 83.5517C37.0032 84.4313 38.2268 84.9222 39.4995 84.9222C40.7722 84.9222 41.9958 84.4313 42.9156 83.5517C43.8354 82.6722 44.3805 81.4717 44.4373 80.2003V32.8662L60.6976 49.1265C61.6376 50.0254 62.8881 50.527 64.1887 50.527C65.4893 50.527 66.7397 50.0254 67.6797 49.1265C68.6054 48.2005 69.1255 46.9448 69.1255 45.6355C69.1255 44.3261 68.6054 43.0704 67.6797 42.1444L39.4995 13.9642L11.3193 42.1444C10.3936 43.0704 9.87356 44.3261 9.87356 45.6355C9.87356 46.9448 10.3936 48.2005 11.3193 49.1265C12.2593 50.0254 13.5098 50.527 14.8103 50.527C16.1109 50.527 17.3614 50.0254 18.3014 49.1265L34.5617 32.8662Z",
    fill: "#FDF9EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToTop);
export default __webpack_public_path__ + "static/media/back-to-top.70b52856eee0b61a87de32a7a3b5496b.svg";
export { ForwardRef as ReactComponent };